export default "__VITE_ASSET__BYUr$KQG__"